import { Row, Col, LucideIcon, Button, Form, DeleteButton, message, useCRUDController, generateShadesFromHex } from './ot'
import dayjs from 'dayjs'
import React, { useEffect, useRef, useState } from 'react'
import CrmDashboard, { CrmDashboardModal } from '../crm_base/crm_dashboard'
import BaseDocumentResponseCanvasEditModal from './../ui/base_document_response_canvas_edit_modal.jsx'

/**
 * US88、US89、US90
 * 要增加props控制按鈕與資訊
 */
const Name4 = ({
    mainApiRoute = "/utility/response/cache",
    dbCoverIdName = "response_id",
    propsCategoryName = "職員",
    propsCategoryTitle = "資料",
    propsPrimaryColor = '#14b8a6',
    propsSecodaryColor = '#22c55e',
    formColumnApi = "/utility/form/newest",
    responseApi = "/utility/response/cache",
    documentApiRoute = "/utility/document/base_view",
    createMode = "modal",
    createApiRoute = '',
    showTabsData = false,
    tabsDataApiRoute,
    tabsDataIdName = "document_id",
    showCreateButtontext,
    extraTabsKey,
    /* 
    整合查詢設定
    showBaseInfoBlock2 = true,
    showHeaderContainer = false,
    showStatsCard = false,
     */
    showBaseInfoBlock2 = false,
    showHeaderContainer = true,
    showStatsCard = true,
    editModal = false,
    baseCardView1_8Props = (handleEditResponsedata, responseController, value) => ({}),
    baseCardView1_5Props = (response_form_value_data) => ({
        // stats:[]
    }),
    propsToolbars = ['patch', 'delete'],
    extraButtonRender = (value) => { return [] },
    propsTabsData,
    /**
     * 問題編號1211-1、問題編號1211-2
     * 統計數據區
     */
    stats,
    /**
     * 問題編號1211-8
     * 增加讓src送false會就不顯示
     */
    /**
     * 問題編號1211-9
     * 補文件兩個props
     */
    propsCodeName = "名稱",
    propsCodeDescription = "描述",
    baseListView1Props,
    columnsPerRow = 4,
    propsGetBaseCardViewData2BaseCardView1_5PropsStats = (document_classify_structure_type_data_first) => [
        {
            value: document_classify_structure_type_data_first?.view_times,
            label: "瀏覽次數",
            backgroundColor: "bg-blue-50",
            animationDuration: 2000,
            animationDelay: 0,
            icon: <LucideIcon name={"Eye"} className="w-4 h-4  text-blue-500" />
        },
        {
            value: document_classify_structure_type_data_first?.clone_times,
            label: "撰寫" + propsCategoryTitle,
            backgroundColor: "bg-green-50",
            animationDuration: 1500,
            animationDelay: 200,
            icon: <LucideIcon name={"FileText"} className="w-4 h-4  text-blue-500" />,
        },
        {
            value: document_classify_structure_type_data_first?.click_times,
            label: "點擊次數",
            backgroundColor: "bg-blue-50",
            animationDuration: 2000,
            animationDelay: 0,
            icon: <LucideIcon name={"MousePointer"} className="w-4 h-4  text-purple-500" />

        },
        {
            value: document_classify_structure_type_data_first?.copy_times,
            label: "複製次數",
            backgroundColor: "bg-green-50",
            animationDuration: 1500,
            animationDelay: 200,
            icon: <LucideIcon name={"TrendingUp"} className="w-4 h-4  text-orange-500" />

        },
    ],
    modalWidth = 1000,
    reponseApiRoute,
    propsLoadRecord,
    ...props
}) => {
    const [modalOpen, setModalOpen] = useState(false)
    const recordRef = useRef()
    const [formColumnApiParams, setFormColumnApiParams] = useState({})
    const [form] = Form.useForm()
    const [reloadCount, setReloadCount] = useState(0)
    const [reloadAndResetCount, setReloadAndResetCount] = useState(0)
    const [tabsDataloading, setTabsDataLoading] = useState(false)
    const [category, setCategory] = useState()
    const handleEditResponsedata = (record) => {
        setModalOpen(true)
        let reaponseValue = {

        }
        record?.response_form_value_data?.forEach((value) => {
            let form_column_form_value_data = value?.form_column_form_value_data || []
            let form_column_form_value_data_first = form_column_form_value_data?.find((_) => true)
            let form_column_id = form_column_form_value_data_first?.form_column_id
            let form_column_component_definition_data_first = form_column_form_value_data_first?.form_column_component_definition_data?.find(_ => true)
            let component_definitions_classify_structure_type_data_first = form_column_component_definition_data_first?.component_definitions_classify_structure_type_data?.find(_ => true)
            let component_type = component_definitions_classify_structure_type_data_first?.component_type
            reaponseValue[`${component_type ?? value?.value_type}+${form_column_id}`] = value?.value?.value
        })
        let reaponseRecord = [reaponseValue]
        recordRef.current = {
            response_id: record?.response_id,
            document_id: record?.document_id,
            reaponseData: reaponseRecord,
            responseValue: propsLoadRecord ? {
                response_id: record?.response_id
            } : record
        }
        setFormColumnApiParams({ document_id: record?.document_id })
    }
    const handleCreateResponsedata = (id, params = {}) => {
        setModalOpen(true)
        recordRef.current = { [dbCoverIdName]: id, ...params }
        setFormColumnApiParams({ [dbCoverIdName]: id, ...params })
    }
    const getBaseCardViewData = (data) => {
        let newdata = data.map((value, index) => {
            let response_form_value_data = value?.response_form_value_data || []
            /**
             * US88、US89、US90
             * 要增加props控制與資訊
             */
            let stats = response_form_value_data.map((value) => {
                let form_column_form_value_data = value?.form_column_form_value_data || []
                let form_column_form_value_data_first = form_column_form_value_data?.find((_) => true)
                let code = form_column_form_value_data_first?.code
                let res_form_column_value = value?.value?.value
                return {
                    value: code,
                    label: res_form_column_value,
                    backgroundColor: "bg-blue-50",
                }
            })

            /**
             * 問題編號1211-9
             * cardview預設拿名稱、描述
             */
            // const codeName = getValueByCode({ code: propsCodeName, response_form_value_data: response_form_value_data })
            // const codeDescription = getValueByCode({ code: propsCodeDescription, response_form_value_data: response_form_value_data })
            const codeName = ""
            const codeDescription = ""
            return {
                key: value?.key,
                cardIndex: index,
                baseCardView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseCardView1_2Props: {
                    /**
                     * 問題編號1211-8
                     * src送false會就不顯示
                     */
                    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKFSgdhQvBlZO6I8s-jtKIYOED1NqEs4xEjA&s"
                },
                baseCardView1_3Props: {
                    /**
                     * 問題編號1211-9
                     * cardview第一行
                     */
                    value: codeName ?? '',
                },
                baseCardView1_4Props: {
                    /**
                     * 問題編號1211-9
                     * cardview第二行
                     */
                    value: codeDescription ?? value?.template_description ?? "",
                },
                baseCardView1_5Props: {
                    stats: stats,
                    ...baseCardView1_5Props(response_form_value_data)
                },
                baseCardView1_6Props: {
                    badges: [
                        {
                            label: value?.create_user_name ?? "-",
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: value?.create_time ? dayjs(value?.create_time).format("YYYY-MM-DD") : "-",
                            variant: "outline",
                            className: ""
                        },
                    ]
                },
                baseCardView1_7Props: {
                    children: <></> //<p className="text-gray-600 mt-1 text-sm">儲存位置：.../.../...</p>
                },
                baseCardView1_8Props: {
                    /**
                     * US88、US89、US90
                     * 要增加props控制按鈕
                     */
                    buttons: [
                        ...(false ? [<Button variant="outline" className="flex-1">
                            <LucideIcon name={"Eye"} className="h-4 w-4 mr-1" />
                            查看
                        </Button>] : []),
                        ...(propsToolbars.includes('patch') ? [<Button
                            onClick={() => {
                                handleEditResponsedata(value)
                            }}
                            className="flex-1">
                            <LucideIcon name={"Edit"} className="h-4 w-4 mr-1" />
                            編輯
                        </Button>] : []),
                        ...(propsToolbars.includes('display') ? [<Button
                            onClick={() => {
                                handleEditResponsedata(value)
                            }}
                            className="flex-1">
                            <LucideIcon name={"Edit"} className="h-4 w-4 mr-1" />
                            詳細資訊
                        </Button>] : []),
                        ...(false ? [<Button variant="ghost" size="sm">
                            <LucideIcon name={"Share"} className="h-4 w-4 mr-1" />
                            分享
                        </Button>,
                        <Button variant="ghost" size="sm">
                            <LucideIcon name={"Download"} className="h-4 w-4 mr-1" />
                            匯出
                        </Button>] : []),
                        ...(propsToolbars.includes('delete') ? [<DeleteButton
                            onConfirm={() => {
                                responseController.deleteData([
                                    {
                                        response_id: value?.response_id
                                    }
                                ])
                            }}
                            style={{}}
                            variant="ghost" size="sm" className="text-red-600"
                        />] : []),
                        ...extraButtonRender(value, props.propsSetReloadAndResetCount !== undefined ? props.propsSetReloadAndResetCount : setReloadAndResetCount)
                    ],
                    buttonGroupsColumnsCount: [2, 3],
                    ...baseCardView1_8Props(handleEditResponsedata, responseController, value)
                },
                ...value
            }
        })
        return newdata
    }
    const getBaseListViewData = (data) => {
        let newdata = data.map((value) => {
            let response_form_value_data = value?.response_form_value_data || []
            let stats = response_form_value_data.map((value) => {
                let form_column_form_value_data = value?.form_column_form_value_data || []
                let form_column_form_value_data_first = form_column_form_value_data?.find((_) => true)
                let code = form_column_form_value_data_first?.code
                let res_form_column_value = value?.value?.value
                return {
                    value: code,
                    label: res_form_column_value,
                    backgroundColor: "bg-blue-50",
                }
            })
            return {
                key: value?.key,
                baseListView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseListView1_2Props: {
                    value: '',
                },
                baseListView1_3Props: {
                    value: value?.template_description ?? "",
                },
                baseListView1_4Props: {
                    stats: stats
                },
                baseListView1_5Props: {
                    badges: [
                        {
                            label: value?.create_user_name ?? "-",
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: value?.create_time ? dayjs(value?.create_time).format("YYYY-MM-DD") : "-",
                            variant: "outline",
                            className: ""
                        },
                    ]

                },
                baseListView1_6Props: {
                    children: <></> //<p className="text-gray-600 mt-1 text-sm">儲存位置：.../.../...</p>
                },
                baseListView1_7Props: {
                    buttons: [
                        ...(false ? [<Button variant="outline" className="flex-1">
                            <LucideIcon name={"Eye"} className="h-4 w-4 mr-1" />
                            查看
                        </Button>] : []),
                        ...(propsToolbars.includes('patch') ? [<Button
                            onClick={() => {
                                handleEditResponsedata(value)
                            }}
                            className="flex-1">
                            <LucideIcon name={"Edit"} className="h-4 w-4 mr-1" />
                            編輯
                        </Button>] : []),
                        ...(propsToolbars.includes('display') ? [<Button
                            onClick={() => {
                                handleEditResponsedata(value)
                            }}
                            className="flex-1">
                            <LucideIcon name={"Edit"} className="h-4 w-4 mr-1" />
                            詳細資訊
                        </Button>] : []),
                        ...(false ? [<Button variant="ghost" size="sm">
                            <LucideIcon name={"Share"} className="h-4 w-4 mr-1" />
                            分享
                        </Button>,
                        <Button variant="ghost" size="sm">
                            <LucideIcon name={"Download"} className="h-4 w-4 mr-1" />
                            匯出
                        </Button>] : []),
                        ...(propsToolbars.includes('delete') ? [<DeleteButton
                            onConfirm={() => {
                                responseController.deleteData([
                                    {
                                        response_id: value?.response_id
                                    }
                                ])
                            }}
                            style={{}}
                            variant="ghost" size="sm" className="text-red-600"
                        />] : []),
                        ...extraButtonRender(value, props.propsSetReloadAndResetCount !== undefined ? props.propsSetReloadAndResetCount : setReloadAndResetCount)
                    ],
                    buttonGroupsColumnsCount: [2, 3],
                },
                baseListView1Props: baseListView1Props,
                ...value
            }
        })
        return newdata
    }
    const getBaseCardViewData2 = (data) => {
        let newdata = data?.map((value) => {
            let name_language_data = value?.name_language_data || []
            let twName = name_language_data?.find((ele) => ele?.language_culture_code === "zh-tw")?.language_value
            let document_classify_structure_type_data = value?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((ele) => true)

            return {
                key: value?.key,
                baseCardView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseCardView1_2Props: {
                    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKFSgdhQvBlZO6I8s-jtKIYOED1NqEs4xEjA&s"
                },
                baseCardView1_3Props: {
                    value: twName || '-',
                },
                baseCardView1_4Props: {
                    value: document_classify_structure_type_data_first?.document_description || '-',
                },
                baseCardView1_5Props: {
                    stats: propsGetBaseCardViewData2BaseCardView1_5PropsStats(document_classify_structure_type_data_first)
                },
                baseCardView1_6Props: {
                    badges: [
                        {
                            label: document_classify_structure_type_data_first?.create_user_name,
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: dayjs(document_classify_structure_type_data_first?.create_time).format("YYYY-MM-DD"),
                            variant: "outline",
                            className: ""
                        },
                    ]
                },
                baseCardView1_7Props: {
                    //尚未串接
                    children: <></> //<p className="text-gray-600 mt-1 text-sm">儲存位置：.../.../...</p>
                },
                baseCardView1_8Props: {
                    buttons: [

                        <Button
                            onClick={() => {
                                handleCreateResponsedata(value?.[dbCoverIdName], { document_id: value?.document_id })
                            }}
                            className="flex-1">
                            <LucideIcon name={"Edit"} className="h-4 w-4 mr-1" />
                            建立內容
                        </Button>,
                    ],
                    buttonGroupsColumnsCount: [2, 3],
                    ...baseCardView1_8Props(handleEditResponsedata, responseController, value)
                },
            }
        })
        return newdata
    }
    const getBaseListViewData2 = (data) => {
        let newdata = data?.map((value) => {
            let document_classify_structure_type_data = value?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((ele) => true)
            let name_language_data = value?.name_language_data || []
            let twName = name_language_data?.find((ele) => ele?.language_culture_code === "zh-tw")?.language_culture_value || "-"

            return {
                key: "1",
                baseListView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseListView1_2Props: {
                    value: twName,

                },
                baseListView1_3Props: {
                    value: document_classify_structure_type_data_first?.document_description || "-",
                },
                baseListView1_4Props: {
                    stats: [
                        {
                            value: document_classify_structure_type_data_first?.view_times,
                            label: "瀏覽次數",
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <LucideIcon name={"Eye"} className="h-4 w-4 text-blue-500" />
                        },
                        {
                            value: document_classify_structure_type_data_first?.clone_times,
                            label: "撰寫文案",
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <LucideIcon name={"FileText"} className="h-4 w-4 text-green-500" />
                        },
                        {
                            value: document_classify_structure_type_data_first?.click_times,
                            label: "點擊次數",
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <LucideIcon name={"MousePointer"} className="h-4 w-4 text-purple-500" />

                        },
                        {
                            value: document_classify_structure_type_data_first?.copy_times,
                            label: "複製次數",
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <LucideIcon name={"TrendingUp"} className="h-4 w-4 text-orange-500" />

                        },
                    ]
                },
                baseListView1_5Props: {
                    badges: [
                        {
                            label: document_classify_structure_type_data_first?.create_user_name,
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: dayjs(document_classify_structure_type_data_first?.create_time).format("YYYY-MM-DD"),
                            variant: "outline",
                            className: ""
                        },
                    ]
                },
                baseListView1_6Props: {
                    children: <></> // <p className="text-gray-600 mt-1 text-sm">儲存位置：.../.../...</p>
                },
                baseListView1_7Props: {
                    buttons: [
                        <Button
                            onClick={() => {
                                handleCreateResponsedata(value?.[dbCoverIdName])
                            }}
                            className="flex-1">
                            <LucideIcon name={"Edit"} className="h-4 w-4 mr-1" />
                            建立內容
                        </Button>,
                    ],
                    buttonGroupsColumnsCount: [2, 3],
                },
            }
        })
        return newdata
    }


    const transformDocumentToTabDatas = ({
        items = [],
    }) => {
        return items?.map(item => (
            {
                showCreateButtontext: true,
                ...(extraTabsKey?.find(itemItem => item?.document_name == itemItem?.document_name) ?? {}),
                key: item?.[tabsDataIdName],
                label: item?.document_name,
                total: "0/0", // 雙數字
                badgeClassname: "bg-[" + generateShadesFromHex("gray")?.["600"] + "]/75 text-[" + generateShadesFromHex("purple")?.["600"] + "]",
                apiRoute: mainApiRoute + `?${tabsDataIdName}=${item?.[tabsDataIdName]}`,
            }
        ))
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                setReloadAndResetCount((pre) => pre + 1)
            } else if (axiosMode === "patch") {
                message.success("修改成功")
                setReloadCount((pre) => pre + 1)
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                setReloadAndResetCount((pre) => pre + 1)

            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                setReloadAndResetCount((pre) => pre + 1)

            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                setReloadCount((pre) => pre + 1)
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                setReloadAndResetCount((pre) => pre + 1)
            }
        }
        if (axiosMode !== "get") {
            // setLoading(false)
            setModalOpen(false);
        }
    }

    const responseController = useCRUDController({
        apiRoute: responseApi,
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                // setLoading(true);
            }
        },
        onFinish: onFinish
    })

    const documentController = useCRUDController({
        apiRoute: tabsDataApiRoute,
    })

    const tabsData = transformDocumentToTabDatas({
        items: documentController?.ResponseData,
        apiRoute: mainApiRoute
    })

    useEffect(() => {
        if (showTabsData) {
            setTabsDataLoading(true)
            documentController.getData({}).finally((e) => {
                setTabsDataLoading(false)
                setCategory(tabsData?.find(_ => true)?.label)
            })
        }
    }, [])


    return <Row>
        <Col span={24}>
            {editModal && <>
                <BaseDocumentResponseCanvasEditModal
                    documentApiRoute={documentApiRoute}
                    formColumnApi={formColumnApi}
                    responseApi={mainApiRoute}
                    open={modalOpen}
                    setOpen={setModalOpen}
                    axiosMode={createMode === "modal" ? "patch" : "post"}
                    propsForm={form}
                    record={recordRef.current}
                    formColumnApiParams={formColumnApiParams}
                    setReloadAndResetCount={setReloadAndResetCount}
                    setReloadCount={setReloadCount}
                    onFinish={onFinish}
                    width={modalWidth}
                    reponseApiRoute={reponseApiRoute}
                    propsLoadRecord={propsLoadRecord}
                />
            </>}
            {!editModal && <>
                <CrmDashboardModal
                    formColumnApi={formColumnApi}
                    responseApi={responseApi}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    axiosMode={createMode === "modal" ? "patch" : "post"}
                    propsForm={form}
                    propsRecord={recordRef.current}
                    formColumnApiParams={formColumnApiParams}
                    setReloadAndResetCount={setReloadAndResetCount}
                    setReloadCount={setReloadCount}

                />
            </>}
        </Col>
        <Col span={24}>
            <CrmDashboard
                editModal={editModal}
                formColumnApi={formColumnApi}
                responseApi={responseApi}
                rowKey={dbCoverIdName}
                pageTitle={propsCategoryName + "資料"} //當範例
                createButtontext={category ?? (propsCategoryName + propsCategoryTitle + '建立')}
                showCreateButtontext={showCreateButtontext}
                createApiRoute={createApiRoute}
                primaryColor={propsPrimaryColor}
                secondColor={propsSecodaryColor}
                apiRoute={mainApiRoute}
                createMode={createMode}
                propsGetBaseCardViewData={(data) => {
                    return createMode === "modal" ? getBaseCardViewData(data) : getBaseCardViewData2(data)
                }
                }
                propsGetBaseListViewData={(data) => {
                    return createMode === "modal" ? getBaseListViewData(data) : getBaseListViewData2(data)
                }}
                propsReloadCount={reloadCount}
                propsSetReloadCount={setReloadCount}
                propsReloadAndResetCount={reloadAndResetCount}
                propsSetReloadAndResetCount={setReloadAndResetCount}
                showBaseInfoView3={showTabsData && !tabsDataloading}
                tabsData={tabsData}
                onSelectTabKey={(e) => {
                    setCategory(tabsData?.find(item => item?.key == e)?.label)
                    setFormColumnApiParams({
                        document_id: e
                    })
                }}
                formColumnApiParams={{
                    document_id: tabsData?.find(_ => true)?.key,
                    ...formColumnApiParams
                }}
                extraTabsKey={extraTabsKey}
                showBaseInfoBlock2={showBaseInfoBlock2}
                showHeaderContainer={showHeaderContainer}
                showStatsCard={showStatsCard}
                propsTabsData={propsTabsData}
                stats={stats}
                columnsPerRow={columnsPerRow}
                {...props}
            />
        </Col>
    </Row>
}
export default Name4
